import { ORGANIZER_TYPES } from "../../../types";
import { init, success, finish, error } from "services/common";
import { LabelListingService } from "./api";

const labelListingService = new LabelListingService();

export const getOrganizerEventLabelListings = () => {
  return async (dispatch) => {
    dispatch(init(ORGANIZER_TYPES.LABELS_EVENTS_LISTING));
    const response = await labelListingService.getOrganizerEventLabelListings();
    dispatch(finish(ORGANIZER_TYPES.LABELS_EVENTS_LISTING));
    if (response.isSuccess) {
      dispatch(success(ORGANIZER_TYPES.LABELS_EVENTS_LISTING, response.data));
    } else if (!response.isSuccess) {
      dispatch(error(response.errorMessage));
    }
  };
};